import {
	apiRequest
} from '../api.js'

// 获取国家优质工程
export function getNewAwork(config){
	config.method = 'post'
	config.url = '/adminapi/web/get-web-case'
	apiRequest(config)
}

//获取文章详情
export function getAtricDetail(config){
	config.method = 'post'
	config.url = '/adminapi/web/get-post-detail'
	apiRequest(config)
}


export function getWebWorkArea(config){
	config.method = 'post'
	config.url = '/adminapi/web/get-web-work-area'
	apiRequest(config)
}

export function getWebRecommendNews(config){
	config.method = 'post'
	config.url = '/adminapi/web/get-web-recommend-news'
	apiRequest(config)
}

export function getWebBanner(config){
	config.method = 'post'
	config.url = '/adminapi/web/get-web-banner'
	apiRequest(config)
}

export function getWebNav(config){
	config.method = 'post'
	config.url = '/adminapi/web/get-web-nav'
	apiRequest(config)
}
export function getSignalPage(config){
	config.method = 'post'
	config.url = '/adminapi/web/get-signal-page'
	apiRequest(config)
}


